import type { GetPresignedUrlForGetPayload } from "@/core/types";

export const usePresignedUrlKey = {
  base: ["presignedUrl"] as const,
  get: (payload: Omit<GetPresignedUrlForGetPayload, "method" | "content_type">) =>
    [...usePresignedUrlKey.base, JSON.stringify(payload)] as const,
};
